module.exports = __webpack_public_path__ + "images/emails/i-2-0d2253a1.gif";